// ============================================================================
// ENGLISH TRANSLATIONS - BIBLE VERSES
// ============================================================================
// Collection of inspiring verses with Strong's references

export const bibleVerses = [
  {
    reference: "Philippians 4:13",
    text: "I can do all things through Christ who strengthens me",
    version: "nkjv",
    theme: "strength",
    strongNumbers: {
      "can": "G1411", // δύναμις (dynamis) = power, strength
      "strengthens": "G1743" // ἐνδυναμόω (endynamoo) = to strengthen
    },
    context: "Paul speaks of his ability to face all situations through Christ"
  },
  {
    reference: "Psalm 23:1",
    text: "The Lord is my shepherd; I shall not want",
    version: "nkjv",
    theme: "protection",
    strongNumbers: {
      "shepherd": "H7462", // רָעָה (ra'ah) = to pasture, tend
      "want": "H2637" // חָסֵר (chaser) = to lack, need
    },
    context: "David expresses total trust in divine providence"
  },
  {
    reference: "John 3:16",
    text: "For God so loved the world that He gave His only begotten Son",
    version: "nkjv",
    theme: "love",
    strongNumbers: {
      "loved": "G25", // ἀγαπάω (agapao) = to love unconditionally
      "gave": "G1325" // δίδωμι (didomi) = to give, offer
    },
    context: "The most famous verse about God's love for humanity"
  },
  {
    reference: "Philippians 4:7",
    text: "And the peace of God, which surpasses all understanding, will guard your hearts",
    version: "nkjv",
    theme: "peace",
    strongNumbers: {
      "peace": "G1515", // εἰρήνη (eirene) = peace, harmony
      "guard": "G5432" // φρουρέω (phroureo) = to guard, protect
    },
    context: "Promise of divine protection through inner peace"
  },
  {
    reference: "Psalm 119:105",
    text: "Your word is a lamp to my feet and a light to my path",
    version: "nkjv",
    theme: "guidance",
    strongNumbers: {
      "lamp": "H5216", // נִיר (niyr) = lamp, light
      "light": "H216" // אוֹר (or) = light, illumination
    },
    context: "God's Word as a guide in daily life"
  },
  {
    reference: "Proverbs 3:5-6",
    text: "Trust in the Lord with all your heart, and lean not on your own understanding",
    version: "nkjv",
    theme: "trust",
    strongNumbers: {
      "trust": "H982", // בָּטַח (batach) = to trust, have confidence
      "heart": "H3820" // לֵב (leb) = heart, mind, will
    },
    context: "Invitation to trust God rather than our own abilities"
  },
  {
    reference: "Matthew 5:14",
    text: "You are the light of the world. A city that is set on a hill cannot be hidden",
    version: "nkjv",
    theme: "witness",
    strongNumbers: {
      "light": "G5457", // φῶς (phos) = light, spiritual illumination
      "world": "G2889" // κόσμος (kosmos) = world, universe
    },
    context: "Jesus encourages his disciples to be witnesses in the world"
  }
];

export default bibleVerses;